exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-67b7e808]{width:80%;margin-left:10%;margin-top:5%}h1[data-v-67b7e808]{text-align:center}p[data-v-67b7e808]{text-align:justify}.cta[data-v-67b7e808]{width:300px;margin:auto;text-align:center}.cta a[data-v-67b7e808]{margin:10px;text-decoration:none;display:inline-block;border:1px solid #521751;border-radius:3px;width:100px;padding:10px;box-sizing:border-box;color:#521751}.cta a[data-v-67b7e808]:active,.cta a[data-v-67b7e808]:hover{background-color:#521751;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67b7e808","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigate/nosotros.vue
// module id = 365
// module chunks = 0